module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonecvm-04@2x.f4167397.jpg";